import {DataTable} from '@cypro/ui/components/ui/data-table'
import {useTradeNameContext} from '@/shared/contexts/trade-name'
import {useAppForm} from '@cypro/ui/integrations/form'
import {fuzzyFilter} from '@/shared/utils/table'
import {Tabs} from '@chakra-ui/react'
import {useStore} from '@tanstack/react-form'
import {getCoreRowModel, getFilteredRowModel, useReactTable} from '@tanstack/react-table'
import {useMemo} from 'react'
import {BatchesColumnsDef} from '../batches-columns'
import type {Batch} from '@cypro/engine/schema'
import {openBatchDrawer} from '@/modules/stocks/batches/components/batch-drawer/util'

export function BatchesTab() {
  const {tradeName} = useTradeNameContext()

  const form = useAppForm({
    defaultValues: {
      search: '',
    },
  })
  const search = useStore(form.store, state => state.values.search)

  const columns = useMemo(() => {
    return [
      BatchesColumnsDef.lotNumber({maxSize: 20}),
      BatchesColumnsDef.expiryDate({maxSize: 15}),
      BatchesColumnsDef.supplierCompany({maxSize: 20}),
      BatchesColumnsDef.stockLocation({maxSize: 15}),
      BatchesColumnsDef.stock({maxSize: 10}),
    ]
  }, [])

  const batches = useMemo(() => {
    if (!tradeName.batches) return []

    const value: Batch[] = []
    for (const batch of tradeName.batches) {
      if (batch) value.push(batch)
    }

    return value
  }, [tradeName])

  const table = useReactTable({
    data: batches,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter(),
    },
    globalFilterFn: 'fuzzy',
    state: {
      globalFilter: search,
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  })

  return (
    <Tabs.Content value="batches" spaceY="8" display="flex" flexDirection="column">
      <form onSubmit={event => event.preventDefault()}>
        <form.AppForm>
          <form.AppField name="search">{field => <field.Searchbox maxWidth="100%" />}</form.AppField>
        </form.AppForm>
      </form>

      <DataTable table={table} onRowClick={openBatchDrawer} />
    </Tabs.Content>
  )
}
